import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h4 className="font-heading text-xl text-background-50 mb-4">
              <Link to="/" className="cursor-pointer hover:text-primary-400 transition-colors">韩漫之家</Link>
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫之家是国内领先的韩国漫画在线阅读平台，提供免费、高清的下拉式韩漫阅读体验。
              从浪漫爱情到热血动作，应有尽有。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/romance" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">浪漫爱情</Link></li>
              <li><Link to="/category/action" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">热血动作</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">奇幻冒险</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/thriller" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">悬疑惊悚</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">轻松喜剧</Link></li>
              <li><Link to="/category/drama" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">都市剧情</Link></li>
              <li><Link to="/category/historical" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">古风历史</Link></li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><a href="/about#contact" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">联系我们</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">隐私政策</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 韩漫之家. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200 cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200 cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200 cursor-pointer" aria-label="QQ">
              <i className="ri-qq-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}